import React from 'react'
import { MainContainer } from '../../components/ContentWrapper'
import { ListPageHeader } from '../../components/ListPageHeader/ListPageHeader'
import { ReportHistorySection } from '../../components/PdpAudit/ReportHistorySection'
import { useNetworkScope } from '../../hooks/useNetworkScope'

// Intelligence > PDP History: every PDP analysis report in the client's
// scope, one history list per report kind. Reports are still RUN from the
// Catalog pages (category rows, brand rows, product PDP URLs); this page is
// the read-only history + downloads for all brand plans, the sibling of
// Consumer Voice History. GET /rmn/audit/reports scopes on
// rmnContext.accessibleBrandIds, so a single brand sees its own reports and
// a network root sees its network's.
export default function RmnPdpHistoryPage() {
  const { isNetwork } = useNetworkScope()
  return (
    <MainContainer>
      <ListPageHeader
        title="PDP History"
        subtitle="Past product page analysis reports, newest first"
      />
      <div className="flex flex-col gap-10">
        <ReportHistorySection
          reportType="category"
          title="Category Reports"
          emptyMessage="No category reports yet. Run one from Catalog > Categories."
        />
        {isNetwork && (
          <ReportHistorySection
            reportType="brand"
            title="Brand Reports"
            emptyMessage="No brand reports yet. Run one from Catalog > Brands."
          />
        )}
        <ReportHistorySection
          reportType="pdp"
          title="Single Product Page Reports"
          emptyMessage="No single product page reports yet."
        />
      </div>
    </MainContainer>
  )
}
